
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getTransactionCashRefund } from "@/api/api-order-service";
import { State } from "vuex-class";
import regular from "@/common/regular";
import i18n from "@/config/i18n";
@Component
export default class PiNonRealRefund extends Vue {
  private formObj: objAny = {};
  private loading = false;
  private ruleInline: objAny = {
    refundAmount: [
      {
        required: true,
        trigger: "blur",
        validator: regular.money
      }
    ]
  };
  formInline: objAny = {};
  disableCode = false;
  win: objAny = window;
  isSuccess = false;
  @State("sys") sys!: objAny;

  async handleRefund() {
    this.isSuccess = true;
    if (this.formInline.refundAmount > this.formInline.accountBalance) {
      this.$Message.error(i18n.t("nonRealNameCardManagement.refundError"));
      return false;
    }
    const params: objAny = {
      accountPkId: this.formInline.accountPkId,
      objectPkId: this.formInline.cardPkId,
      refundAmount: this.formInline.refundAmount
    };

    this.loading = true;
    const ret = await getTransactionCashRefund(params);
    if (ret.status == this["$config"].apiStatus) {
      this.$Modal.success({
        title: i18n.t("nonRealNameCardManagement.refundSuccess") + "",
        content: `<p>${i18n.t("commonTableName.orderNo")}：${
          ret.data[0].orderNo
        }</p><p>${i18n.t("accountBalance")}：${
          ret.data[0].afterBalance
        }${i18n.t("yuan")}</p>`,
        onOk: () => {
          this["$common"].goBack();
        }
      });
    }
    this.loading = false;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.handleRefund();
      }
    });
  }
  mounted() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });

    const localData = this["$common"].get("non-real-name-card-management-item");
    if (localData) {
      if (this.formInline.accountPkId != localData.accountPkId) {
        localData.refundAmount = "";
        this.$set(this, "formInline", localData);
      }
    }
  }
}
